<template>
  <div>

    
    
   

    <!-- ends here -->
    <v-app-bar style="background-image: linear-gradient(to right,#02aab0 , #00cdac);padding-bottom:10px;"
      
      dense
       
      fixed
       
    >

     <!-- <v-btn v-if="titleval == 'Home'" icon v-b-toggle.sidebar-1 class="d-block d-lg-none d-xl-none ">
        <v-icon>mdi-format-align-justify</v-icon>
      </v-btn>
       <v-btn icon v-else to="/" class="d-block d-lg-none d-xl-none ">
        <v-icon>mdi-keyboard-backspace</v-icon>
      </v-btn> -->
      <v-btn v-if="titleval == 'Home'" icon v-b-toggle.sidebar-1 class="d-block d-lg-none d-xl-none ">
        <v-icon>mdi-format-align-justify</v-icon>
      </v-btn>
       <!-- <v-btn icon v-else to="/" >
        <v-icon>mdi-keyboard-backspace</v-icon>
      </v-btn> -->

       <v-btn icon v-else @click="$router.go(-1)">
        <v-icon>mdi-keyboard-backspace</v-icon>
      </v-btn>


     

      <v-toolbar-title  class="d-block d-lg-none d-xl-none ">{{titleval}}</v-toolbar-title>
      <v-toolbar-title  class="d-none d-lg-flex d-xl-flex" style="    font-family: fantasy;">eBearer</v-toolbar-title>

         <!-- big screen nav here -->
              
<div style="padding-left:100px;" class="d-none d-lg-flex d-xl-flex">
           
   <nav class="navbar navbar-expand-sm d-none d-lg-flex d-xl-flex" style="backgroung:#fff0;color:#000">
  <ul class="navbar-nav">
    <li class="nav-item" style="padding-left:1.5em; padding-right:1em;cursor:pointer;">
      <a class="nav-link" style="color:#000;" @click="loadpage('/')">Home</a>
    </li>
    <li class="nav-item" style="padding-left:1.5em; padding-right:1em; cursor:pointer;">
      <a class="nav-link" @click="loadpage('/wishlist')" style="color:#000;">Favorites</a>
    </li>
    <li class="nav-item" style="padding-left:1.5em; padding-right:1em;cursor:pointer;">
      <a class="nav-link" @click="loadpage('/offerzone')" style="color:#000;">Offer Zone</a>
    </li>
   
    <li class="nav-item" style="padding-left:1.5em; padding-right:2em;cursor:pointer;">
      <a class="nav-link" v-b-toggle.sidebar-1 style="color:#000;">Categories</a>
    </li>
     <li class="nav-item" style="padding-left:1.5em; padding-right:1em;cursor:pointer;">
      <a class="nav-link" @click="loadpage('/account')" style="color:#000;">My Account</a>
    </li>
    
    
  </ul>
</nav>

</div>

         <!-- big screen nav ends here -->




       <!-- <b-form-input  placeholder="Search Items"  v-show="titleval == 'Search Items'"  autofocus v-model="searchitm" ></b-form-input>   -->
      <v-spacer></v-spacer>

     <b-sidebar id="sidebar-1" title="eBearer" shadow>
      <div class="px-3 py-2">

 <!-- <p style="color: goldenrod;text-align: left;" class="d-none d-lg-flex d-xl-flex">Menu</p>
 <b-list-group style="text-align:left;" class="d-none d-lg-flex d-xl-flex">
  <p @click="loadpage('/')"><v-icon>mdi-home</v-icon>&nbsp;Home</p>
  <p @click="loadpage('/wishlist')"> <v-icon>mdi-heart</v-icon>&nbsp;Favorites</p>
  <p @click="loadpage('/offerzone')"> <v-icon>mdi-gift</v-icon>&nbsp;Offer Zone</p>
  <p @click="loadpage('/account')"><v-icon>mdi-account</v-icon> &nbsp;Account</p>
 
</b-list-group> -->

        <p style="color: goldenrod;text-align: left;">Categories </p>
        <div class="scrollcate">
         <b-list-group  v-for="(cat, i) in categories"
          :key="i" style="text-align:left;">
          <p  @click="loadsubcategory(cat)" class="d-flex justify-content-between align-items-center">{{cat}} <b-badge  style="background:#fff0 !important;"><v-icon class="pull-right">mdi-chevron-right</v-icon></b-badge></p>
  
    
        </b-list-group>
        </div>
      
      </div>
    </b-sidebar>
       
      <v-btn icon to="/search">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
      

     
    
       <v-btn icon v-b-toggle.sidebar-right hidden>
        <v-icon>mdi-sort</v-icon>
      </v-btn>

      <b-sidebar id="sidebar-right" title="Sidebar" right shadow>
      <div class="px-3 py-2">
        <p>
         right
        </p>
       
      </div>
    </b-sidebar>
  
     
 
     

    <div @click="opencheckout">
    
      
      <v-icon>mdi-cart</v-icon>
     
    </div>
     <span style="margin-top:2em;"><sup v-if="cartlength" style="padding:3px; border-radius:6px; color:#000;    background: red;" >{{cartlength}}</sup></span>
    </v-app-bar>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import Router from '../router';
// @ is an alias to /src
// import itemoffer from '@/components/Offer.vue'

export default {
   
  props: ['titleval'],
  data () {
    return {
      page:{
          name : 'Product',
          intro : 'Welcome to',
          

      },
      home:'home',
      modalShow: false,
      show : false,
      searchshow : false,
      countitem:'',
      cartNo:'',
      cartlength:'',
      title:'',
      searchitm:'',
      categories:[]
     
    
    }
  },
  watch: {
    cartlength: function(newValue, oldValue) {
      console.log(newValue, oldValue)
      if(newValue == null)
      {
        this.cartlength = localStorage.cartcount
      }else{
          this.cartlength = newValue;
      }
     
    },
    searchitm: function(newValue,oldValue)
    {
      this.$parent.$children[0].$parent.searchval = this.searchitm
      this.$seach = newValue
    }
  },
  
    mounted() {
      this.home = this.$parent.$children[0].$parent.ttlval
     this.cartNo = localStorage.getItem("cartcount");
      // this.cartlength = localStorage.getItem("cartcount")
     this.countitem = this.$parent.$children[0].$parent.itemcountnumber
     this.getcategories();
    //  console.log(this.$parent.$children[0].$parent.ttlval); 
     if(this.cartlength != 0)
     {
       this.show =true;
     }
            this.getcartItems()
            if(this.$cartcount != 0){
               this.countitem = localStorage.getItem('countitemno');
               

            }
           

    
       },
   methods: {

     loadsubcategory(cat){
      //  console.log(cat)
      const path = `/catogory?cat=${cat}`
if (this.$route.path !== path) this.$router.push(path)  
          // Router.push('/catogory');
          this.$parent.$children[0].$parent.catname = cat
          localStorage.setItem("catName", cat);
     },
     loadpage(cat){
          if (this.$route.path !== cat) this.$router.push(cat)  
          // Router.push(cat);
        
     },
     


     //=-----------------------------------------------------
         getcategories: function ()      {

      axios.get(this.$bURL+"item/GetItemCategories")
      .then((response)  =>  {
        // this.loading = false;
        this.categories = response.data;
          
      }, (error)  =>  {
          console.log(error)
      })

     },
    getcartItems: function () {
      // this.loading = true;
      // localStorage.getItem(JSON.parse('cartlist'))
    },
    opencheckout: function()
    {
         this.$router.push('/checkout')
    },
   
      toggleModal() {
        // We pass the ID of the button that we want to return focus to
        // when the modal has hidden
        this.$refs['my-modal'].toggle('#toggle-btn')
      }
    
  },
}
</script>
<style scoped>
.v-toolbar__content{
  background-color: #009900 !important;
}
.list-group-item {
   
    padding: 0rem 0.5rem !important;
    border-bottom: 1px solid #000 !important;
}
.scrollcat{
  overflow: scroll;
  max-height: 320px;
}
</style>